import { Component, OnInit } from '@angular/core';
import { BaseControlComponent } from "../../../../../../../form-controls/components/base-control/base-control.component";
import { ContextInteractionService } from "../../../../../../../form-controls/services/context-interaction.service";


@Component({
    selector: 'app-casing-plan-schematic-data-config',
    templateUrl: './casing-plan-schematic-data-config.component.html',
    styleUrls: ['./casing-plan-schematic-data-config.component.scss'],
    standalone: false
})
export class CasingPlanSchematicDataConfigComponent extends BaseControlComponent implements OnInit {

    static componentName = "CasingPlanSchematicDataConfigComponent";

    get casingPlanLocation(): string {
        if (this.componentData.config == null) this.componentData.config = {};
        if (this.componentData.config.casingPlanLocation == null) this.componentData.config.casingPlanLocation = "";
        return this.componentData.config.casingPlanLocation;
    }

    set casingPlanLocation(value: string) {
        this.componentData.config.casingPlanLocation = value;
    }

    get applicationNumber(): string {
        if (this.componentData.config == null) this.componentData.config = {};
        if (this.componentData.config.applicationNumber == null) this.componentData.config.applicationNumber = "";
        return this.componentData.config.applicationNumber;
    }

    set applicationNumber(value: string) {
        this.componentData.config.applicationNumber = value;
    }

    get wellName(): string {
        if (this.componentData.config == null) this.componentData.config = {};
        if (this.componentData.config.wellName == null) this.componentData.config.wellName = "";
        return this.componentData.config.wellName;
    }

    set wellName(value: string) {
        this.componentData.config.wellName = value;
    }

    get wellNumber(): string {
        if (this.componentData.config == null) this.componentData.config = {};
        if (this.componentData.config.wellNumber == null) this.componentData.config.wellNumber = "";
        return this.componentData.config.wellNumber;
    }

    set wellNumber(value: string) {
        this.componentData.config.wellNumber = value;
    }


    constructor(contextService: ContextInteractionService) {
        super(contextService);
    }

    ngOnInit() {
    }

}
